<template>
	<div class="drawer">
		<el-drawer
		size="450px"
		:visible.sync="drawerStatus"
		@close='handleClose'
		:append-to-body="true"
		:title="'添加护理日志'"
		:wrapperClosable="false"
		>
			<el-form :inline="true" class="form">
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="护理时间:" :label-width="formLabelWidth" required>
							<span style="margin-right: 5px;">{{$public.FTime(nurseDate.getTime(),'YYYY-MM-DD')}}</span>
							<el-time-picker v-model="nurseDate" placeholder="任意时间点" style="width:120px;"></el-time-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="服务人员:" :label-width="formLabelWidth" required>
							<el-select v-model="staffChecked" filterable placeholder="请选择" style="width:250px;" >
								<el-option v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
								:value="item._id+','+item.basic_info.nick_name"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="护理类目:" :label-width="formLabelWidth" required>
							<el-select v-model="nurseType" placeholder="请选择" style="width:250px;">
								<el-option v-for="item in [{value: '喂食',label: '喂食'},{value: '铲屎',label: '铲屎'}]" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="描述:" :label-width="formLabelWidth">
							<el-input v-model="nurseRemark" type="textarea" :rows="5" style="width:250px;" placeholder="请录入描述"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="体温:" :label-width="formLabelWidth">
							<el-input v-model="animalHeat" @input="changeInput('animalHeat')" style="width:250px;" placeholder="请输入">
								<template slot="append">摄氏度</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="呼吸:" :label-width="formLabelWidth">
							<el-input v-model="breatheRate" @input="changeInput('breatheRate')" style="width:250px;" placeholder="请输入">
								<template slot="append">次/分</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="体重:" :label-width="formLabelWidth">
							<el-input v-model="weight" @input="changeInput('weight')" style="width:250px;" placeholder="请输入">
								<template slot="append">千克</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="心率:" :label-width="formLabelWidth">
							<el-input v-model="heartRate" @input="changeInput('heartRate')" style="width:250px;" placeholder="请输入">
								<template slot="append">次/分</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="handleClose">取消</div>
				<div class="btnItem submit" @click="submitCode">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth:'90px',
				
				staffChecked:'',
				staffList:[],
				
				// "goodsItemsId": "",  // 订单子项关联id
				"animalHeat": "",   // 体温
				"weight": "",  // 体重
				"breatheRate": "",  // 呼吸率
				"heartRate": "",  // 心率
				"nurseType": "",  // 护理类型
				"nurseRemark": "",  //护理备注
				"serviceUserId": "",  // 服务人员id
				"serviceUserName": "",  //服务人员
				nurseDate:new Date(),  // 时间
			}
		},
		computed:{
			
		},
		props:{
			goodsItemsId:{
				default:''
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
			this.getStaffList();
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			changeInput(str){
				if(str==='animalHeat'){
					this.animalHeat = this.$public.replaceGoodsDosage(this.animalHeat)
				}else if(str==='weight'){
					this.weight = this.$public.replaceGoodsDosage(this.weight)
				}else if(str==='breatheRate'){
					this.breatheRate = this.$public.replaceGoodsDosage(this.breatheRate)
				}else if(str==='heartRate'){
					this.heartRate = this.$public.replaceGoodsDosage(this.heartRate)
				}
			},
			submitCode(){
				if(this.$public.isNull(this.nurseDate)){
					this.$message({
						message: '请选择护理时间',
						type: 'error'
					});
					return ;
				}
				if(this.$public.isNull(this.staffChecked)){
					this.$message({
						message: '请选择服务人员',
						type: 'error'
					});
					return ;
				}
				if(this.$public.isNull(this.nurseType)){
					this.$message({
						message: '请选择护理类目',
						type: 'error'
					});
					return ;
				}
				let params = {
					"goodsItemsId": this.goodsItemsId,  // 订单子项关联id
					"animalHeat": this.animalHeat,   // 体温
					"weight": this.weight,  // 体重
					"breatheRate": this.breatheRate,  // 呼吸率
					"heartRate": this.heartRate,  // 心率
					"nurseType": this.nurseType,  // 护理类型
					"nurseRemark": this.nurseRemark,  //护理备注
					"serviceUserId": this.staffChecked.split(',')[0],  // 服务人员id
					"serviceUserName": this.staffChecked.split(',')[1],  //服务人员
					nurseDate:this.$public.FTimeStr10(this.nurseDate),  // 时间
				}
				console.log(params)
				this.$http.post('/api/FosterCare/NurseRecord/Add', params).then(res => {
					if (res.code == 0) {
						this.$emit('submit',{type:'success'})
					}
				})
			},
			getStaffList() {
				let params = {
					// "keyword": '医助',
					"pageIndex": 1,
					"pageSize": 500,
				}
				this.$http.get('/api/Staff/List', params).then(res => {
					if (res.code == 0) {
						this.staffList = res.data.data;
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.form{
				::v-deep .el-form-item{
					margin:5px 0;
				}
			}
		}
		
	}
	.btnBox{
		width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
		.btnItem{
			text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
			&.submit{
				background-color: $mainColor;
			}
		}
	}
</style>
